import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../Assets/javascripts/common/others/SharedDispatcher";

  /**
   * Product visuals view (top left thumbnails)
   * 
   * @todo Manage "no image" case in Nav\Core\Product\Header\Left\Visuals.ascx
   * 
   * @property {integer} headerHeight                Website header height (in pixels)
   * @property {integer} visualCount                 Number of visuals
   * @property {integer} visualIndex                 Current visual index
   * @property {integer} visualThumbnailWidth        Thumbnail width including margin/padding (in pixels)
   * @property {integer} visualVisibleThumbnailCount Current visual index
   * 
   * @property {object}  $visualBox 
   * @property {object}  $visualImages     
   */
  export default Backbone.View.extend({

    el: ".js-ProductVisuals",

    /**
     * Constructor
     *
     * @todo Refactor (copy of ProductStickyView.js scrollToAnchor() method)
     *       this.headerHeight property is part of it
     */
    initialize: function() {
      this.headerHeight = $(".js-Header").eq(0).height();
      this.visualCount = this.$(".js-ProductVisuals-item").length;
      this.visualIndex = 0;
      this.visualThumbnailWidth = 60;
      this.visualVisibleThumbnailCount = Math.floor(this.$(".js-ProductVisualsThumbnails-list").width() / this.visualThumbnailWidth);

      this.$visualImagePreview = this.$(".js-ProductVisuals-imagePreview");
      this.$visualBox = this.$(".js-ProductVisuals-box");
      this.$visualBoxImage = this.$(".js-ProductVisualsBox-image");
      this.listenTo(SharedDispatcher, 'product-visual:changeTempImage', this.changeWithTempImage);
      this.render();
    },

    events: {
      "mouseover .js-ProductVisuals-item"                         : "switchPreview",
      "click     .js-ProductVisuals-item, .js-ProductVisuals-zoom": "selectItem",
      "click     .js-ProductVisuals-previous"                     : "previous",
      "click     .js-ProductVisuals-next"                         : "next",
      "click     .js-ProductVisuals-zoom"                         : "toggleBox",
      "click     .js-ProductVisualsBox-close"                     : "toggleBox"
    },

    changeWithTempImage: function(src) {
      this.$visualImagePreview.attr("src", src);
    },

    /**
     * [switchPreview description]
     *
     * @todo Waiting for the video visuals
     * 
     * @param {object} event
     */
    switchPreview: function(event) {
      var $target = $(event.target);
      var $thumbnail = $target.is(".js-ProductVisuals-item") ? $target : $target.parents(".js-ProductVisuals-item");
      if ($thumbnail.data("type") === "video") {
        return;
      }
      this.visualIndex = $thumbnail.index();
      this.loadPreview();
    },

  loadPreview: function() {
    var $thumbnail = $(".js-ProductVisuals-thumbnails .js-ProductVisuals-item").eq(this.visualIndex);
    var $boxThumbnail = $(".js-ProductVisualsBox-thumbnails .js-ProductVisuals-item").eq(this.visualIndex);

    this.$visualImagePreview.attr("src", $thumbnail.data("src"));
    this.$visualBoxImage.attr("src", $thumbnail.data("src-zoom"));
    this.$(".ProductVisuals-item--active").removeClass("ProductVisuals-item--active");
    $thumbnail.addClass("ProductVisuals-item--active");
    $boxThumbnail.addClass("ProductVisuals-item--active");
  },

  previous: function() {
    this.visualIndex = ((this.visualIndex === 0) ? this.visualCount : this.visualIndex) - 1;

    if ($(".js-ProductVisuals-thumbnails .js-ProductVisuals-item").eq(this.visualIndex).data("type") === "video") {
      this.previous();
    }

    this.loadPreview();
  },

  next: function() {
    this.visualIndex = (this.visualIndex === (this.visualCount - 1)) ? 0 : this.visualIndex + 1;

    if ($(".js-ProductVisuals-thumbnails .js-ProductVisuals-item").eq(this.visualIndex).data("type") === "video") {
      this.next();
    }

    this.loadPreview();
  },

  selectItem: function(event) {
    event.preventDefault();
      
    var $target = $(event.target);
    var $thumbnail = $target.is(".js-ProductVisuals-item") ? $target : $target.parents(".js-ProductVisuals-item");
      
    switch ($thumbnail.data("type")) {
      case "image":
        if (!$thumbnail.parents("div").first().hasClass("js-ProductVisualsBox-thumbnails")) {
          this.toggleBox();
        }
        break;

      case "video":
        this.scrollToVideo();
        break;
    }
  },

  /**
   * @todo Refactor (copy of ProductStickyView.js scrollToAnchor() method)
   */
  scrollToVideo: function () {
    if (!$("#strate-video-player").length) {
      return;
    }

    $("html, body").stop().animate({
      scrollTop: $("#strate-video-player").offset().top - (this.headerHeight - 1)
    }, 600, "swing");
  },

  toggleBox: function () {
    this.$visualBox.toggle();
  },

  render: function() {
    this.$(".js-ProductVisuals-item").first().addClass("ProductVisuals-item--active");

    this.$(".js-ProductVisualsBox-thumbnails")
      .html(this.$(".js-ProductVisuals-thumbnails").html())
      .find('[data-type="video"]').remove();

    // We update the box image
    this.$(".js-ProductVisualsBox-image").attr("src", $(".js-ProductVisuals-thumbnails .js-ProductVisuals-item").eq(this.visualIndex).data("src-zoom"));
  }

});
